<template>

<form
  class="mx-auto col-sm-12"
  @submit.prevent
>
  <b-alert
    :show="alert.show"
    @dismissed='alert.show = false'
    dismissible
    fade
    :variant="alert.type"
  >
    {{ alert.message }}
  </b-alert>

  <div class="row">
    <div class="form-group col-lg-12">
      <label for="client">{{ $t("client") }}</label>
      <Combobox
        class="bg-white"
        name="client"
        :placeholder="$t('select_a_item')"
        :options="clients"
        :initial-value="client"
        label="CLI_DSC"
        v-model="client"
        :reduce="(client) => client.CLI_ID"
      />
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="getVehiclesAndAreas"
      >
        {{ $t('search') }}
      </LoaderButton>
    </div>
  </div>

  <div class="row" v-if="vehiclesAndAreasByClient.vehicles.length && vehiclesAndAreasByClient.areas.length">
    <div class="form-group col-lg-12">
      <label for="vehicle">{{ $t("vehicle") }}</label>
      <Combobox
        class="bg-white"
        name="vehicle"
        :placeholder="$t('select_a_item')"
        :hasErrors="errors.has('vehicle')"
        :options="vehiclesAndAreasByClient.vehicles"
        :initial-value="vehicle"
        :getOptionLabel="vehicle => mountVehicleLabel(vehicle)"
        v-model="vehicle"
        :reduce="(vehicle) => vehicle.id"
        v-validate="'required'"
      />

      <small v-show="errors.has('vehicle')" class="form-text text-muted">
        {{ errors.first("vehicle") }}
      </small>
    </div>

    <div class="form-group col-lg-12">
      <label for="area">{{ $t("area") }}</label>
      <Combobox
        class="bg-white"
        name="area"
        :placeholder="$t('select_a_item')"
        :hasErrors="errors.has('area')"
        :options="vehiclesAndAreasByClient.areas"
        :initial-value="area"
        label="ARE_DSC"
        v-model="area"
        :reduce="(area) => area.id"
        v-validate="'required'"
      />

      <small v-show="errors.has('area')" class="form-text text-muted">
        {{ errors.first("area") }}
      </small>
    </div>

    <div
      class="form-group col-lg-6"
      :class="{ 'has-error': errors.has('home') }"
    >
      <label for="start">{{ $t('home') }}</label>
      <input
        type="datetime-local"
        id="start"
        name="start"
        class="form-control"
        :placeholder="$t('ph_home')"
        v-model="start"
      />

      <small v-show="errors.has('home')" class="form-text text-muted">
        {{ errors.first("home") }}
      </small>
    </div>

    <div
      class="form-group col-lg-6"
      :class="{ 'has-error': errors.has('end') }"
    >
      <label for="end">{{ $t('end') }}</label>
      <input
        type="datetime-local"
        id="end"
        name="end"
        class="form-control"
        :placeholder="$t('ph_end')"
        v-model="end"
      />

      <small v-show="errors.has('end')" class="form-text text-muted">
        {{ errors.first("end") }}
      </small>
    </div>
  </div>

  <div class="form-group row" v-if="vehiclesAndAreasByClient.vehicles.length && vehiclesAndAreasByClient.areas.length">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="linkVehicleAndArea"
      >
        {{ $t('link') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'LinkVehicleAndAreaGenerateEventsForm',
  components: {
    LoaderButton,
    Combobox
  },

  data() {
    return {
      client: undefined,
      area: undefined,
      vehicle: undefined,
      start: '',
      end: '',
      alert: {
        show   : false,
        type   : 'success',
        message: 'Definido veículo para o Ativo'
      }
    }
  },

  watch: {
    client: function(value) {
      this.$store.commit('arena/cleanVehicleAndAreaByClient')
    }
  },

  computed: {
    ...mapState({
      clients: (state) => state.arena.clients,
      vehiclesAndAreasByClient: (state) => state.arena.vehiclesAndAreasByClient
    })
  },

  methods: {
    async getVehiclesAndAreas() {
      if (!this.client) {
        const err = new Error('Selecione um cliente');

        this.$store.dispatch("notify/error", err);

        return
      }

      await this.$store.dispatch(
        'arena/fetchVehiclesAndAreasByClient',
        { client: this.client }
      )
    },

    async linkVehicleAndArea() {
      if (!this.client) {
        const err = new Error('Selecione um cliente');

        this.$store.dispatch("notify/error", err);

        return
      }

      const result = await this.$store.dispatch(
        'arena/linkVehicleAndArea',
        {
          vehicle: this.vehicle,
          area: this.area,
          start: this.start,
          end: this.end,
        }
      )

      if (result) {
        this.$router.push({ name: "listarenalinkvehicleandareagenerateevents" });
      }
    },

    mountVehicleLabel(vehicle) {
      const { EQP_SRN, VEI_DSC, VEI_PLC } = vehicle

      const fields = [EQP_SRN, VEI_DSC, VEI_PLC]

      return fields.join(' / ')
    }
  },

  async mounted () {
    this.start = moment().format('YYYY-MM-DDT00:00')

    this.end = moment().add(30, 'years').format('YYYY-MM-DDT23:59')

    await this.$store.dispatch("arena/fetchClients")
  },
}
</script>
